import { render, staticRenderFns } from "./CriteoTable.vue?vue&type=template&id=285bd1e2&"
import script from "./CriteoTable.vue?vue&type=script&lang=js&"
export * from "./CriteoTable.vue?vue&type=script&lang=js&"
import style0 from "./CriteoTable.vue?vue&type=style&index=0&id=285bd1e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports